import { Pipe, PipeTransform } from '@angular/core'
import { FormGroup } from '@angular/forms'
import { Dictionary } from '@ngrx/entity'
import { Store } from '@ngrx/store'
import { take } from 'rxjs/operators'
import { AppState } from 'src/app/core/core.state'
import { bookingSelectors } from 'src/app/features/booking/booking.selectors'
import { Product } from '../../../product/product'

@Pipe({
  name: 'isBookedDuringStay'
})
export class IsBookedDuringStayPipe implements PipeTransform {
  constructor(private store: Store<AppState>) {}
  transform(
    formProducts: any[],
    productId: number,
    productEntities: Dictionary<Product>,
    bookedProductDuringStayWithDate: any
  ) {
    if (!formProducts) {
      console.warn(`productForm is null for productId: ${productId}`)
      return false
    }

    return bookedProductDuringStayWithDate.filter(
      (bk) => bk.productId === productId
    ).length > 0
      ? true
      : false
  }
}
